import { makeStyles } from '@material-ui/core/styles';

export const useAdvancedFiltersStyles = makeStyles(theme => ({
  dateSlash: {
    height: '32px',
    width: '1px',
    marginLeft: '50%',
    background: 'black',
    display: 'flex',
    alignSelf: 'flex-end'
  },
  date: {
    position: 'absolute',
    width: '50%',
    bottom: '0',
    '& .MuiInputBase-input': {
      textAlign: 'center'
    }
  },
  dateLeft: {
    left: 0
  },
  dateRight: {
    right: 0
  },
  dateWrapper: {
    display: 'flex',
    position: 'relative'
  }
}));
